import * as localStorageService from '../services/localStorageService';

export default () => {
  return localStorageService.getItem('dlt');
};
